<template>
    <!-- <div>dasd</div> -->
    <ul style="list-style: none; margin-left: 20px; margin-top: 20px; font-size: 18px;">
        <li>纸飞机：@XB188</li>
        <li>纸飞机：@jh288</li>
        <li>纸飞机：@xb168</li>
        <li>纸飞机：@XB868</li>
        <li>QQ：97889930</li>
        <li>QQ：508788821</li>
        <li>skpye：live:22480_1</li>
    </ul>
    <!-- <div class="member_recharge">
        <div class="tit">
            缴费账号：{{account}}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {{formatTimestamp()}} 到期
        </div>
        <div class="bd_1">
            <div class="item " :class="paymode == 'kami' ? 'active' : ''" @click="clickPayMode('kami')">
                <p>
                    <img src="../../assets/images/member/kami.png" alt="">
                </p>
                <p>
                    卡密模式
                </p>
                <i class="icon-selected"></i>
            </div>
            <div class="item"  :class="paymode == 'bzk' ? 'active' : ''" @click="clickPayMode('bzk')">
                <p>
                    <img width="45" src="../../assets/images/member/icon_bzk.png" alt="">
                </p>
                <p>
                    宝转卡支付
                </p>
                <i class="icon-selected"></i>
            </div>
            <div class="item"  :class="paymode == 'usdt' ? 'active' : ''" @click="clickPayMode('usdt')">
                <p>
                    <img width="45" src="../../assets/images/member/icon_usdt.png" alt="">
                </p>
                <p>
                    USDT
                </p>
                <i class="icon-selected"></i>
            </div>
        </div>
        <div class="bd_2" v-if="paymode == 'kami'">
            <div class="item" v-for="(item,i) in buy_url_arr" :class="buy_index === i ? 'active': ''" @click="changeBuy(i)">
                {{item.title}}<i class="icon-selected"></i>
            </div>           
        </div> -->
        <!-- <div class="bd_2" v-if="paymode == 'bzk'">
            <div class="item" v-for="(item,i) in bzk_buy_url_arr" :class="buy_index === i ? 'active': ''" @click="changeBzkBuy(i)">
                {{item.title}}<i class="icon-selected"></i>
            </div>           
        </div>
        <div class="bd_2" v-if="paymode == 'usdt'">
            <div class="item" v-for="(item,i) in usdt_buy_url_arr" :class="buy_index === i ? 'active': ''" @click="changeUsdtBuy(i)">
                {{item.title}}<i class="icon-selected"></i>
            </div>           
        </div> -->
        <!-- <div class="tit" v-if="paymode == 'kami'">
            支付金额：<span>{{buy.money}}</span> 元
            &nbsp;&nbsp;&nbsp;
            充值后 {{expiration_time}} 到期
        </div>
        <div class="tit" v-if="paymode == 'bzk'">
            支付金额：<span>{{buy.money2}}</span> 元 <b class="del">({{buy.money}}元)</b>
            &nbsp;&nbsp;&nbsp;
            充值后 {{expiration_time}} 到期
        </div>
        <div class="tit" v-if="paymode == 'usdt'">
            支付金额：<span>{{buy.money2}}</span> 元 <b class="del">({{buy.money}}元)</b>
            &nbsp;&nbsp;&nbsp;
            充值后 {{expiration_time}} 到期
        </div> -->
        <!-- <div class="bd_3" v-if="paymode == 'kami'">
            <textarea class="text" name="cdkey" id="cdkey" v-model="cdkey" ></textarea>
            <div class="operation">
                <div class="btn btn-1" @click="openBuy">购买卡密</div> -->
                <!-- <div class="btn btn-2" @click="submitExchange">卡密兑换</div> -->
                <!-- <el-button class="btn btn-2" @click="submitExchange" :loading="submit_loading">卡密兑换</el-button>
            </div>
        </div>
        <div class="bd_3" v-if="paymode == 'bzk'">
            <div class="operation">
                <div class="btn btn-1" @click="openBuy">立即支付</div>
            </div>
        </div>
        <div class="bd_3" v-if="paymode == 'usdt'">
            <div class="operation">
                <div class="btn btn-1" @click="openBuy">立即支付</div>
            </div>
        </div> -->
        <!-- <template v-if="(paymode == 'bzk' || paymode == 'usdt') && tableData.length > 0">
            <div class="tit">
                支付记录
            </div>
            <div>
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                    prop="create_date"
                    label="日期"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="order_id"
                    label="订单号"
                    width="250">
                </el-table-column>
                <el-table-column
                    prop="rmb_amount"
                    label="金额"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="方式"
                    width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 2">USDT</div>
                        <div v-else>宝转卡</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status == 2" @click="handleClickPay(scope.row)" type="primary" size="small">去支付</el-button>
                        <el-button v-if="scope.row.status == 2" @click="handleClickCancel(scope.row, scope.row.type)" type="danger" size="small">取消订单</el-button>
                        <el-tag v-if="scope.row.status == 3" type="success">已支付</el-tag>
                        <el-tag v-if="scope.row.status == 4" type="info">已取消</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            </div>
        </template> -->
        <!-- <template v-if="paymode == 'usdt' && tableData.length > 0">
            <div class="tit">
                USDT 支付记录
            </div>
            <div>
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                    prop="create_date"
                    label="日期"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="order_id"
                    label="订单号"
                    width="250">
                </el-table-column>
                <el-table-column
                    prop="rmb_amount"
                    label="金额"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="通道"
                    width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 2">USDT</div>
                        <div v-else>宝转卡</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status == 2" @click="handleClickPay(scope.row)" type="primary" size="small">去支付</el-button>
                        <el-button v-if="scope.row.status == 2" @click="handleClickCancel(scope.row,2)" type="danger" size="small">取消订单</el-button>
                        <el-tag v-if="scope.row.status == 3" type="success">已支付</el-tag>
                        <el-tag v-if="scope.row.status == 4" type="info">已取消</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            </div>
        </template> -->

        <!-- <div class="bd_4">
            <p v-if="paymode == 'kami'">
                卡密购买网址：<a :href="buy.url" target="_blank">{{buy.url}}</a>
            </p>
            <p>
                充值客服：<a target="_blank" href="https://chat.ss-chat.com/service/fikl2p">https://chat.ss-chat.com/service/fikl2p</a>
            </p>
            <p>
                少女计划官方网站地址：<a :href="config.off_url" target="_blank">{{config.off_url}}</a>
            </p>
            <p>
                温馨提示：缴费成功后一定要重新登录！
            </p> -->
            <!-- <p v-if="config.qq">
                少女计划官方唯一QQ：<a>{{config.qq}}</a>
            </p> -->
            <!-- <p>
                不能支付，点击复制到浏览器继续支付：<a href="javascript:;" >复制</a>
            </p> -->
        <!-- </div> -->

        <!-- <div class="DialogIframe" v-if="usdt.visible">
            <div class="bg"></div>
            <div class="bd" :style="{width: usdt.width +'px',height: usdt.height +'px'}">
                <iframe class="iframe" v-if="usdt.buy_url" :src="usdt.buy_url" :height="usdt.height" :width="usdt.width" frameborder="0"></iframe>
            </div>
        </div> -->
    <!-- </div> -->
</template>

<script>    
    import { mapGetters } from 'vuex';
    import { getConfig,getPayUrl,getOrderList,getClearOrder,getBzyPayUrl ,getUsdtPayUrl } from '@/api/config.js';
    import { exCdkey,getUser } from '@/api/user.js';
    import { timestampToTime,trim } from '@/utils/common.js'
    export default {
        data() {
            return {
                config: {},
                buy_url_arr: [],
                bzk_buy_url_arr: [],
                usdt_buy_url_arr: [],
                usdt: {
                    visible: false,
                    buy_url: "",
                    height: "",
                    width: ""
                },
                buy_index: 0,
                paymode: 'kami',
                buy: {},
                cdkey:'',
                expiration_time: '',
                submit_loading: false,
                user_id: 0,
                tableData: []
            };
        },        
        computed: {
            ...mapGetters(['token','account','expire_time'])
        },
        created() {
            this.getConfig();
            getUser().then((response)=>{
                this.user_id = response.data.data.id;
                //this.getOrderList(1);
            });
        },
        methods: {
            clickPayMode(val) {
                this.paymode = val;
                if(val == 'usdt') {
                    this.changeUsdtBuy(0);
                    this.getOrderList(2)
                } else if(val == 'bzk') {
                    this.changeBzkBuy(0);
                    this.getOrderList(1)
                } else {
                    this.changeBuy(0)
                }
            },
            getOrderList(type = 1){
                getOrderList(this.user_id,type).then((response)=>{
                    this.tableData = [];
                    if(response.data.data && response.data.data.length > 0) {
                        this.tableData = response.data.data;
                    }
                })
            },
            getBzyBuyUrl() {
                
                let amount = this.buy_url_arr[this.buy_index].money;
                getBzyPayUrl(this.user_id,amount).then((response)=>{
                    console.log('getBzyBuyUrl-response:',response)
                    if(response.data.code == 200) {
                        let url = response.data.data;
                        this.openPayUrl(url);
                        //三方地址 禁止 iframe
                        //this.usdt.visible = true;
                        // this.usdt.buy_url = url;
                        // this.usdt.width = 650;
                        // this.usdt.height = parseInt(document.documentElement.clientHeight * 0.8);
                        
                        this.getOrderList(1);
                    } else {
                        this.$alert(response.data.msg);
                    }
                })
            },
            getUsdtBuyUrl() {
                
                let amount = this.buy_url_arr[this.buy_index].money;
                getUsdtPayUrl(this.user_id,amount).then((response)=>{
                    console.log('getUsdtPayUrl-response:',response)
                    if(response.data.code == 200) {
                        let url = response.data.data;
                        this.openPayUrl(url);
                        //三方地址 禁止 iframe
                        //this.usdt.visible = true;
                        // this.usdt.buy_url = url;
                        // this.usdt.width = 650;
                        // this.usdt.height = parseInt(document.documentElement.clientHeight * 0.8);
                        
                        this.getOrderList(2);
                    } else {
                        this.$alert(response.data.msg);
                    }
                })
            },
            getConfig() {
                getConfig().then((response)=>{
                    this.config = response.data.data;
                    this.buy_url_arr = [];
                    for(let key in this.config.buy_url) {
                        let item = this.config.buy_url[key];
                        item.key = key;
                        this.buy_url_arr.push(item);
                    }
                    if(this.buy_url_arr.length > 0) {
                        this.changeBuy(0)
                    }

                    this.usdt_buy_url_arr = [];
                    for(let key in this.config.usdt_buy_url) {
                        let item = this.config.usdt_buy_url[key];
                        item.key = key;
                        this.usdt_buy_url_arr.push(item);
                    }

                    this.bzk_buy_url_arr = [];
                    for(let key in this.config.bzk_buy_url) {
                        let item = this.config.bzk_buy_url[key];
                        item.key = key;
                        this.bzk_buy_url_arr.push(item);
                    }
                    
                })
            },
            formatTimestamp() {
                if(this.expire_time) {
                    return timestampToTime(this.expire_time);
                }
            },
            changeBuy(i) {
                this.buy_index = i;
                this.buy = this.buy_url_arr[i];
                let end_timestamp = 0;
                //当前时间戳
                let now_timestamp = Date.parse(new Date()) / 1000;
                if(this.expire_time && this.expire_time > now_timestamp) {
                    end_timestamp = Number(this.expire_time) + Number(this.buy.time)
                } else {
                    end_timestamp = Number(now_timestamp) + Number(this.buy.time)
                }
                this.expiration_time = timestampToTime(end_timestamp);
            },
            changeUsdtBuy(i) {
                this.buy_index = i;
                this.buy = this.usdt_buy_url_arr[i];
                let end_timestamp = 0;
                //当前时间戳
                let now_timestamp = Date.parse(new Date()) / 1000;
                if(this.expire_time && this.expire_time > now_timestamp) {
                    end_timestamp = Number(this.expire_time) + Number(this.buy.time)
                } else {
                    end_timestamp = Number(now_timestamp) + Number(this.buy.time)
                }
                this.expiration_time = timestampToTime(end_timestamp);
            },
            changeBzkBuy(i) {
                this.buy_index = i;
                this.buy = this.bzk_buy_url_arr[i];
                let end_timestamp = 0;
                //当前时间戳
                let now_timestamp = Date.parse(new Date()) / 1000;
                if(this.expire_time && this.expire_time > now_timestamp) {
                    end_timestamp = Number(this.expire_time) + Number(this.buy.time)
                } else {
                    end_timestamp = Number(now_timestamp) + Number(this.buy.time)
                }
                this.expiration_time = timestampToTime(end_timestamp);
            },
            openBuy() {
                if(this.paymode === 'usdt') {
                    return this.getUsdtBuyUrl();
                }
                if(this.paymode === 'bzk') {
                    return this.getBzyBuyUrl();
                }
                window.open(this.buy.url, "_blank");
            },
            submitExchange() {
                if(this.submit_loading) {
                    return 0;
                }
                if(trim(this.cdkey) == '') {
                    this.$alert('请输入卡密');
                    return 0;
                }
                this.submit_loading = true;
                exCdkey(trim(this.cdkey)).then((response)=>{
                    this.submit_loading = false;
                    if(response.data.code == 200) {
                        this.cdkey = '';
                        this.$store.commit('SET_EXPIRE_TIME', response.data.data.expire_time);
                        this.$message({
                            message: response.data.msg,
                            type: 'success'
                        });
                        this.changeBuy(this.buy_index)
                    } else {
                        this.$alert(response.data.msg);
                    }
                })
            },
            handleClickPay(item) {
                this.openPayUrl(item.paymentUrl)
            },
            handleClickCancel(item,type = 1) {
                getClearOrder(this.user_id,item.order_id,type).then((response)=>{
                    if(response.data.code == 200) {
                        this.$message({
                            message: response.data.msg,
                            type: 'success'
                        });
                        this.getOrderList(type);
                    } else {
                        this.$alert(response.data.msg);
                    }
                })
            },
            openPayUrl(url) {
                let left = (document.documentElement.clientWidth - 850) / 2,top = (document.documentElement.clientHeight - 700) / 2;
                window.open(url, 'customeService', 'width=850,height=700,top=' + top + ',left=' + left);
            }

        }
    }
</script>

<style lang="scss">
    .DialogIframe {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(#000000, 0.5);
        z-index: 9;
        .bd{
            position: relative;
            .iframe {
                top: 0;
                left: 0 !important;
            }
        }
    }
    .member_recharge {
        padding: 15px 12px;
        box-sizing: border-box;  
        .tit {
            height: 45px;
            display: flex;
            align-items: center;
            border-top: 2px solid #E0BB8F;
            background: #EDDCCC;
            box-sizing: border-box;
            color: #88522a;
            font-size: 14px;
            padding-left: 15px;
            margin-top: 12px;
            span {
                color: #ff4545;
            }
            .del {
                color: #696969;
                text-decoration: line-through;
                font-weight: 500;
                font-size: 12px;
            }
        }
        .icon-selected {
            position: absolute;
            width: 40px;
            height: 40px;
            background-image: url('../../assets/images/member/selected.png');
            right: 0;
            bottom: 0;
            display: none;
        }
        .bd_1 {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            .item {
                width: 160px;
                height: 100px;
                box-sizing: border-box;
                background: #FFF6E7;
                border: 2px solid #c58d3abd;
                border-radius: 10px;
                font-size: 18px;
                color: #c58c39;
                display: flex;
                flex-flow: column;
                justify-content: center;
                align-items: center;
                position: relative;
                cursor: pointer;
                &.disable {
                    cursor: initial;
                    i {
                        background-image: none;
                        display: block;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.2);
                        top: 0;
                        left: 0;
                        border-radius: 10px;
                    }
                }
                + .item {
                    margin-left: 40px;
                }
                &.active {
                    i {
                        display: block;
                    }
                }
            }
        }
        .bd_2 {
            display: flex;
            margin-top: 20px;
            justify-content: center;
            .item{
                width: 140px;
                height: 55px;
                box-sizing: border-box;
                background: #FFF6E7;
                border: 2px solid #C58D3A;
                border-radius: 5px;
                font-size: 18px;
                color: #c58c39;
                display: flex;
                align-items: center;
                position: relative;
                justify-content: center;
                cursor: pointer;
                + .item {
                    margin-left: 40px;
                }
                &.active {
                    i {
                        display: block;
                    }
                }
            }
        }
        .bd_3 {
            display: flex;
            margin-top: 20px;
            .text {
                width: 550px;
                height: 90px;
                box-sizing: border-box;
                border: 1px solid #DDA76B;
                padding: 10px;
                font-size: 14px;
                resize: none;
                outline:none
            }
            .operation {
                width: 150px;
                margin-left: 15px;
                display: flex;
                flex-flow: column;
                justify-content: space-between;
                .btn {
                    width: 150px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    box-sizing: border-box;
                    border-radius: 5px;
                    color: #fff;
                    font-size: 18px;
                    cursor: pointer;   
                    padding: 0;                 
                }
                .btn-1 {
                    background: linear-gradient(#9A681F, #BC8533);
                    &:hover {
                        background: linear-gradient(#9A681F, #9A681F);
                    }
                }
                .btn-2 {
                    background: linear-gradient(#E54841, #CD3D35);
                    &:hover {
                        background: linear-gradient(#CD3D35, #E54841);
                    }
                }
            }
        }
        .bd_4 {
            margin-top: 20px;
            p {
                line-height: 25px;
                font-size: 14px;
                color: #88522a;
                a {
                    color: #e90e0e;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/member/recharge.vue